export const getHost = () => {
  if (window.location.hostname === 'localhost') {
    return 'http://65620d9b3230.ngrok.io';
  }
  return window.location.protocol + '//' + window.location.hostname;
};
